exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label {\n  text-transform: uppercase;\n}\n:host /deep/ .btn-link {\n  color: #a01d5b;\n}\n:host /deep/ .btn-link:hover {\n  color: #286090;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/rooster/admin/src/app/timepicker/timepicker.component.less
// module id = ../../../../../src/app/timepicker/timepicker.component.less
// module chunks = 1